import { useState } from "react";
import { Row, Col, Form, Input } from "antd";
import MaskedInput from "antd-mask-input";
import { HJAddressSelectBox } from "@FORMS";

const { TextArea } = Input;

const CreateReceiver = ({ form }) => {
  const [cityId, setCityId] = useState(null);
  const [townId, setTownId] = useState(null);

  return (
    <>
      <Row gutter={24}>
        <Col span={8}>
          <Form.Item
            name={"firstName"}
            label="Adı:"
            onKeyPress={(e) => {
              if (!/[a-zA-Z wığüşöçĞÜŞÖÇİ]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: "Lütfen geçerli ad giriniz!",
              },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name={"lastName"}
            label="Soyadı:"
            onKeyPress={(e) => {
              if (!/[a-zA-Z wığüşöçĞÜŞÖÇİ]/.test(e.key)) {
                e.preventDefault();
              }
            }}
            rules={[
              {
                required: true,
                message: "Lütfen geçerli soyad giriniz!",
              },
            ]}
          >
            <Input maxLength={100} />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            name={"phone"}
            label="Telefon Numarası:"
            rules={[
              {
                required: true,
                message: "Lütfen geçerli bir telefon numarası giriniz!",
              },
              () => ({
                validator(_, value) {
                  if (!value || value.includes("_")) {
                    return Promise.reject(
                      new Error("Lütfen geçerli bir telefon numarası giriniz!")
                    );
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <MaskedInput mask="111 111 11 11" size="10" />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="İl:"
            name={"recipientCity"}
            rules={[
              {
                required: true,
                type: "object",
                message: "Lütfen il seçiniz",
              },
            ]}
          >
            <HJAddressSelectBox
              type="city"
              onChange={(val) => {
                setCityId(val);
                setTownId(null);
                if (val?.forced) {
                  form.setFieldsValue({
                    recipientTown: null,
                    recipientDistrict: null,
                  });
                }
              }}
            />
          </Form.Item>
        </Col>

        <Col span={8}>
          <Form.Item
            label="İlçe:"
            name={"recipientTown"}
            rules={[
              {
                required: true,
                type: "object",
                message: "Lütfen ilçe seçiniz",
              },
            ]}
          >
            <HJAddressSelectBox
              type="town"
              cityId={cityId}
              onChange={(val) => {
                setTownId(val);
                if (val?.forced) {
                  form.setFieldsValue({
                    recipientDistrict: null,
                  });
                }
              }}
              deliveryType={"HX_STD"}
            />
          </Form.Item>
        </Col>
        <Col span={8}>
          <Form.Item
            label="Mahalle:"
            name={"recipientDistrict"}
            rules={[
              () => ({
                validator(_, value) {
                  if (typeof value === "string") {
                    form.setFieldsValue({
                      recipientDistrict: null,
                    });
                  }
                  return Promise.resolve();
                },
              }),
            ]}
          >
            <HJAddressSelectBox
              type="district"
              townId={townId}
              deliveryType={"HX_STD"}
            />
          </Form.Item>
        </Col>
      </Row>
      <Form.Item
        label="Ev/İş Yeri Adresi:"
        name={"recipientAddressLine"}
        rules={[
          {
            required: true,
            message: "Lütfen geçerli bir adres giriniz!",
          },
        ]}
      >
        <TextArea
          autoSize={{
            minRows: 1,
            maxRows: 3,
          }}
          maxLength={250}
        />
      </Form.Item>
    </>
  );
};

export default CreateReceiver;
